import { render, staticRenderFns } from "./AgeingTemplate.vue?vue&type=template&id=e672371e"
import script from "./AgeingTemplate.vue?vue&type=script&lang=js"
export * from "./AgeingTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports